<template>
    <div class="orders-preparation-progress-bars">
        <OrderPreparationProgressBar
            class="mb-1"
            :label="'PRODUCTIONS LIEUX DE RETRAIT'"
            :preparation-status="pickupPointsProductionsStatus"
        />
        <OrderPreparationProgressBar
            class="mb-1"
            :label="'CLIENTS LIEUX DE RETRAIT'"
            :preparation-status="pickupPointsSubcustomersStatus"
        />
        <OrderPreparationProgressBar
            class="mb-1"
            :label="'MAGASINS'"
            :preparation-status="storesStatus"
        />
        <OrderPreparationProgressBar
            class="mb-1"
            :label="'CIRCUITS COURTS'"
            :preparation-status="shortChannelsStatus"
        />
        <OrderPreparationProgressBar
            :label="'GROUPEMENTS DE CLIENTS'"
            :preparation-status="customerGroupsStatus"
        />
    </div>
</template>

<script>
    import OrderPreparationProgressBar from "./CustomerOrder/OrderPreparationProgressBar"

    export default {
        name: 'OrdersPreparationProgressBars',

        components: {
            OrderPreparationProgressBar,
        },

        props: {
            pickupPointsProductionsStatus: {
                type: Object,
                required: true,
            },
            pickupPointsSubcustomersStatus: {
                type: Object,
                required: true,
            },
            shortChannelsStatus: {
                type: Object,
                required: true,
            },
            customerGroupsStatus: {
                type: Object,
                required: true,
            },
            storesStatus: {
                type: Object,
                required: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .orders-preparation-progress-bars {
        width: 100%;

        .progress-text {
            position: absolute;
            color: black;
            width: 100%;
            text-align: center;
            line-height: 2rem;
        }

        .progress {
            height: 2rem !important;
            font-size: 1.2rem;
            position: relative;

            @media (max-width: 1300px) {
                font-size: 1rem;
            }

            @media (max-width: 700px) {
                font-size: 0.8rem;
                font-weight: bold;
            }

            @media (max-width: 700px) {
                font-size: 0.6rem;
            }
        }
    }
</style>
